import 'amfe-flexible';
import Vue from 'vue';
import App from './App';
import { router } from './router';
import global from './components/global_variable.js';
import axios from 'axios';
import _ from 'lodash';

Vue.prototype._ = _;
Vue.prototype.$axios = axios;
Vue.prototype.COMMON = global;

new Vue({
  router,
  el: '#app',
  render: h => h(App),
});
